export const company = {
  name: 'North Star Exterior Cleaning',
  legalName: 'North Star Exterior Cleaning Pressure Washing LLC',
  phone: '(971) 706-1595',
  phoneHref: 'tel:+19717061595',
  email: 'northstarexteriorcleaning95@gmail.com',
  facebook: 'https://www.facebook.com/p/North-Star-Exterior-Cleaning-61566115681027/',
  google: 'https://maps.app.goo.gl/TfXMULEByDZH8Huz7',
  mapEmbed: 'https://www.google.com/maps?q=North+Star+Exterior+Cleaning+Salem+Oregon&output=embed',
  hours: 'Mon – Sat, 7am – 7pm',
  base: 'Salem, Oregon',
  logo: 'https://cdn.magicpatterns.com/uploads/kZfZ3oASrwmhRTqf77q3vD/image.png',
  heroImage: 'https://cdn.magicpatterns.com/uploads/wCsr2HW2E5JPzcJghZPf1X/image.png'
};
export const serviceAreas: string[] = ['Salem, OR', 'Keizer, OR', 'Silverton, OR', 'Albany, OR', 'Corvallis, OR', 'McMinnville, OR', 'Oregon City, OR', 'Portland, OR'];
export const reels: string[] = ['https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1499348398026800%2F&show_text=false&width=267&t=0'];
export const promises: string[] = ['Free estimates', 'Senior & veteran discounts', 'Licensed & insured', 'Soft wash safe for shingles'];